import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { useBillingLapsedQuery } from '@/queries/billing'

// Only shown when there is something to review: a reservation the app never
// reported is closed with nothing charged (D15), and this is where it surfaces.
export function LapsedSection({ accountId }: { accountId: number }) {
  const { t, i18n } = useTranslation()
  const { data = [] } = useBillingLapsedQuery(accountId)
  if (data.length === 0) return null

  const when = (iso: string) => new Date(iso).toLocaleString(i18n.language)
  return (
    <section className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold">{t('billing.lapsed.title')}</h2>
        <p className="text-sm text-muted-foreground">{t('billing.lapsed.description')}</p>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('billing.lapsed.payer')}</TableHead>
              <TableHead>{t('billing.lapsed.operation')}</TableHead>
              <TableHead>{t('billing.lapsed.credits')}</TableHead>
              <TableHead>{t('billing.lapsed.started')}</TableHead>
              <TableHead>{t('billing.lapsed.lapsed')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.reservation_id}>
                <TableCell className="font-mono text-xs">{row.payer}</TableCell>
                <TableCell className="font-mono text-xs">{row.operation_id}</TableCell>
                <TableCell>{row.credits}</TableCell>
                <TableCell>{when(row.created_at)}</TableCell>
                <TableCell>{when(row.lapsed_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  )
}
